import { memo } from "react";

import TableHead from "ds/components/Table/Head";
import { getHeadColumnKey } from "ds/components/Table/Head/helpers";
import { selectVisibleColumns } from "ds/components/Table/store/useTableStore/selectors";

import PersonalSettingsSpacesTableHeadColumn from "./Column";
import usePersonalSettingsSpacesTableStore from "../usePersonalSettingsSpacesTableStore";

const PersonalSettingsSpacesTableHead = memo(() => {
  const columns = usePersonalSettingsSpacesTableStore(selectVisibleColumns);

  return (
    <TableHead>
      {columns.map((column, i) => (
        <PersonalSettingsSpacesTableHeadColumn
          isLast={i === columns.length - 1}
          key={getHeadColumnKey(column)}
          column={column}
        />
      ))}
    </TableHead>
  );
});

PersonalSettingsSpacesTableHead.displayName = "PersonalSettingsSpacesTableHead";

export default PersonalSettingsSpacesTableHead;
